module.exports = "<svg style=\"width: 16px; height: 17px\" viewBox=\"0 0 16 17\"><path d=\"M8.57252759e-16,2 L14.001,2 L14.001,14.001 L1.22403448e-16,14.001 L0,16 L16,16 L16,1.0658141e-14 L9.79717439e-16,7.10542736e-15 L8.57252759e-16,2 Z M4.468,12.243 L5.882,10.829 L3.802,9 L12.001,9 L12.001,7 L3.802,7 L5.882,5.172 L4.468,3.757 L0.224,8 L4.468,12.243 Z\" id=\"Icon\" stroke=\"none\" fill=\"#333333\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/logout.svg
// module id = 1296
// module chunks = 0